import { login, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const emptyProfile = () => ({
  id: null,
  username: '',
  realName: '',
  adminLevel: 0,
  avatar: ''
})

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    profile: emptyProfile()
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PROFILE: (state, profile) => {
    state.profile = { ...emptyProfile(), ...profile }
    if (profile && profile.avatar) {
      state.avatar = profile.avatar
    }
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { username, password, captchaCode, captchaKey } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password,
        captchaCode: captchaCode,
        captchaKey: captchaKey
      }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        if (data.userInfo) {
          const u = data.userInfo
          commit('SET_PROFILE', {
            id: u.id,
            username: u.username,
            realName: u.realName,
            adminLevel: u.adminLevel != null ? u.adminLevel : 0,
            avatar: u.avatar
          })
          commit('SET_NAME', u.realName || u.username || '')
          commit('SET_AVATAR', u.avatar || 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        if (!data) {
          return reject('验证失败，请重新登录。')
        }
        const u = data.userInfo
        if (!u) {
          return reject('验证失败，请重新登录。')
        }
        commit('SET_PROFILE', {
          id: u.id,
          username: u.username,
          realName: u.realName,
          adminLevel: u.adminLevel != null ? u.adminLevel : 0,
          avatar: u.avatar
        })
        commit('SET_ROLES', ['ADMIN'])
        commit('SET_NAME', u.realName || u.username || '')
        commit('SET_AVATAR', u.avatar || 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  logout({ commit, state }) {
    return new Promise((resolve) => {
      removeToken()
      resetRouter()
      commit('RESET_STATE')
      resolve()
    })
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken()
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
